import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=6eac100b&scoped=true"
import script from "./Promotion.vue?vue&type=script&lang=js"
export * from "./Promotion.vue?vue&type=script&lang=js"
import style0 from "./Promotion.vue?vue&type=style&index=0&id=6eac100b&prod&scoped=true&lang=css"
import style1 from "../../assets/styles/inventory.css?vue&type=style&index=1&id=6eac100b&prod&scoped=true&lang=css&external"
import style2 from "./Promotion.vue?vue&type=style&index=2&id=6eac100b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eac100b",
  null
  
)

export default component.exports